module.exports = __webpack_public_path__ + "img/geshihua.6203cd50.png";